import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker policy: we used to register a cache-first PWA shell here.
// That caused stale-bundle pain on every redeploy — login would fail or data
// would appear missing because the cached JS still talked to the old API
// contract. PWA wasn't a hard requirement (schedules need live data anyway),
// so we now actively NUKE any existing service worker for this origin so
// returning users always get a fresh app.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        try { await reg.unregister(); } catch (_) { /* ignore */ }
      }
      // Also flush any caches the old SW left behind. The SW itself does this
      // during its activate step, but we do it here too for users who already
      // bricked their cache before the killer SW was deployed.
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (_) {
      // Best-effort cleanup. If anything fails the app still works.
    }
  });
}
